export default __webpack_public_path__ + "static/media/Print Deposit Slip2.9a7c2a2b.svg";